import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function CustomRedirectFCE() {
  const navigate = useNavigate();

  useEffect(() => {
    // открыть в новой вкладке
    window.open("https://fitcropedit.com", "_blank");

    // редиректнуть текущую вкладку на главную
    navigate("/", { replace: true });
  }, [navigate]);

  return null; // ничего не рендерим
}




export default CustomRedirectFCE;
